/* RESPONSIBLE TEAM: team-standalone */

import { tracked } from '@glimmer/tracking';
import { isPresent } from '@ember/utils';
import {
  type FieldType,
  type IntercomAttributeType,
} from 'embercom/objects/standalone/data-fields/common';

export interface UserFieldResponse {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  is_mappable?: boolean;
  intercom_cda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  intercom_sda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  unique?: boolean;
  filterable?: boolean;
  createable?: boolean;
  updateable?: boolean;
  built_in?: boolean;
}

export class UserField {
  id: string;
  name: string;
  description?: string;
  type: FieldType;
  required: boolean;
  isMappable?: boolean;
  @tracked isSynchronizing?: boolean = false;
  intercom_cda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  intercom_sda?: {
    identifier: string;
    type: IntercomAttributeType;
  };
  unique?: boolean;
  filterable?: boolean;
  createable?: boolean;
  updateable?: boolean;
  builtIn: boolean;

  constructor(response: UserFieldResponse) {
    this.id = response.id;
    this.name = response.name;
    this.description = response.description;
    this.type = response.type;
    this.required = response.required;
    this.isMappable = response.is_mappable;
    this.intercom_cda = response.intercom_cda;
    this.intercom_sda = response.intercom_sda;
    this.unique = response.unique;
    this.filterable = response.filterable;
    this.createable = response.createable;
    this.updateable = response.updateable;
    this.builtIn = response.built_in || false;
  }

  get intercomAttributeIdentifier() {
    return this.intercom_cda?.identifier || this.intercom_sda?.identifier;
  }

  get intercomSdaIdentifier() {
    return this.intercom_sda?.identifier;
  }

  get synchronized() {
    return isPresent(this.intercom_cda?.identifier);
  }
}
